import { AlertController, NavController, Keyboard, LoadingController } from 'ionic-angular';
import { Component } from '@angular/core';
import { UserService } from '../../services/user.services';
import { AppConfigService } from '../../services/appConfig.service';
import { AppDialog } from "../../component/appDialog";
import { ReportDTDetailsPage } from "../reportDTDetails/reportDTDetails";

//和账变样式一致
@Component({
    templateUrl: 'reportDTSearch.html',
    selector: 'report-d-t-search-page',
})
export class ReportDTSearchPage {
    starttime: any;
    endtime: string;
    mindate: string;
    maxdate: string;

    constructor(private keyboard: Keyboard, private nav: NavController, private alertCtrl: AlertController, private userService: UserService, private loadingCtrl: LoadingController) {
        this.initService();
        this.getMinMaxDate();
    }

    initService() {
        this.userService.reportTDInit(undefined, this.alertCtrl).then(data => {
            if (!data["msg"]) {
                this.starttime = data["stime2"];
                this.endtime = data["etime2"];
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    searchFn() {
        let requestData: any = {
            stime2: this.starttime.replace("T", ' ').substr(0, 19),
            etime2: this.endtime.replace("T", ' ').substr(0, 19),
        };
        this.userService.reportTDSearch(requestData, this).then(data => {
            if (!data["msg"]) {
                this.nav.push(ReportDTDetailsPage, {
                    data: data
                });
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }

    ionViewWillLeave() {
        this.keyboard.close();
    }

    getMinMaxDate() {
        let today = new Date();
        this.maxdate = today.toISOString().slice(0, 10);
        let minDay = today.setDate(today.getDate() - 35);
        this.mindate = new Date(minDay).toISOString().slice(0, 10);
      }
    
}



// WEBPACK FOOTER //
// ./src/pages/reportDTSearch/reportDTSearch.ts